import { Link as RouterLink } from 'react-router-dom';
import { Link, Breadcrumbs, Typography } from '@mui/material';

import { usePageData } from '../PageData/PageData';
import './Breadcrums.scss';
import PageTitleSkeleton from '../Loader/PageTitleSkeleton';

const Breadcrums = () => {
  const { isLoading, pageBreadcrumbs } = usePageData();

  return (
    <>
      {isLoading ? (
        <PageTitleSkeleton count={pageBreadcrumbs?.length || 2} />
      ) : (
        <Breadcrumbs
          separator={
            <Typography
              component='span'
              variant='h5'
              fontWeight={400}
              color='secondary.main'
              mx={0.5}
            >
              |
            </Typography>
          }
          aria-label='breadcrumb'
          marginRight='auto'
        >
          {(pageBreadcrumbs || []).map((item, index) => {
            const name = item?.title;
            const isLast = index === pageBreadcrumbs.length - 1;
            const isSingleItem = pageBreadcrumbs.length === 1;

            if (isLast || item?.isActive) {
              return (
                <Typography
                  component='h4'
                  variant='h5'
                  key={name}
                  color='secondary.main'
                  fontWeight={isLast && isSingleItem ? 700 : 400}
                >
                  {name}
                </Typography>
              );
            }

            return (
              <Link
                key={item?.path}
                underline='none'
                color='primary.main'
                component={RouterLink}
                to={item?.path}
                state={item?.routeState}
              >
                <Typography component='span' variant='h5'>
                  {name}
                </Typography>
              </Link>
            );
          })}
        </Breadcrumbs>
      )}
    </>
  );
};

export default Breadcrums;
